export const appName = "ATP_DEALERS";
export const appFullName = "AutoTrade Port Dealers";
export const appLogo_url = "";
export const appContact_number = "+923030303030";
export const colors = {
  primary: "#2563eb",
  primaryDark: "#1d4ed8",
  primaryLight: "#3b82f6",
  secondary: "#0f172a",
  secondary2: "#dbeafe",
  info: "#f7f8fa",
  info_5: "rgb(204, 204, 204,0.5)",
  infoPlus: "#eef2f7",
  primaryInfo: "#dbeafe",
  success: "#06b6d4",
  error: "#dd0808",
  warning: "#c4a052",
  black: "#000",
  white: "#fff",
};
